export const getLocalStorage = (state) => state.localStorage;
